import type { ReactNode } from 'react';

type Props<Value> = {
  value: Value;
  activeValue: Value;
  id: string;
  'aria-labelledby': string;
  children?: ReactNode;
  keepMounted?: boolean;
};

export function TabPanel<Value>(props: Props<Value>) {
  const isActive = props.value === props.activeValue;

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={props.id}
      aria-labelledby={props['aria-labelledby']}
    >
      {isActive || props.keepMounted ? props.children : null}
    </div>
  );
}

export type { Props as TabPanelProps };
